var React = require('react');

function Cart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m14.0003 5c0-.53043-.2107-1.03914-.5858-1.41421-.375-.37508-.8837-.58579-1.4142-.58579-.5304 0-1.0391.21071-1.4142.58579-.3751.37507-.5858.88378-.5858 1.41421m9.26 4.696 1.385 9c.0438.2848.0256.5758-.0536.8529-.0791.2772-.2171.5339-.4047.7527-.1875.2188-.4202.3945-.682.5151-.2617.1205-.5465.183-.8347.1833h-13.33998c-.28837 0-.57333-.0623-.83536-.1827-.26202-.1204-.49491-.2961-.6827-.5149-.18778-.2188-.32602-.4757-.40524-.753-.07921-.2773-.09753-.5684-.0537-.8534l1.385-9c.07265-.47241.31208-.90318.67492-1.2143.36285-.31111.82511-.482 1.30308-.4817h10.56798c.4778-.00006.9398.17094 1.3025.48203.3626.31109.6009.74173.6735 1.21397z","stroke":"#111827","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5"}));
}

Cart.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = Cart;

Cart.default = Cart;
